import { useEffect, useState } from "react";
import { Modal, Button, FormLabel } from "@components";
import { resolutionReasons } from "../common";
import SearchSelect from "./SearchSelect";

const ResolveQueryModal = ({ isOpen, onClose, onResolve, submitting }) => {
  const [reason, setReason] = useState(null);
  const [comment, setComment] = useState("");
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (isOpen) return;
    setReason(null);
    setComment("");
    setSubmitted(false);
  }, [isOpen]);

  const handleResolve = () => {
    setSubmitted(true);
    if (reason) onResolve({ resolutionReason: reason, resolutionComment: comment.trim() || undefined });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Resolve query">
      <div className="flex flex-col gap-5 p-5 sm:p-6 bg-white">
        <SearchSelect
          label="Resolution reason"
          placeholder="Select a reason…"
          value={reason}
          onSelect={(r) => setReason(r ?? null)}
          displayValue={(r) => r}
          getKey={(r) => r}
          sortBy={(r) => r}
          renderOption={(r) => <span className="text-sm text-zinc-900">{r}</span>}
          options={resolutionReasons}
          filterOption={(r, term) => r.toLowerCase().includes(term.toLowerCase())}
          emptyText="No reasons"
          error={submitted && !reason ? "Please select a resolution reason" : null}
        />

        <div>
          <FormLabel>
            Comment <span className="text-zinc-400 font-normal">(optional)</span>
          </FormLabel>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={3}
            maxLength={500}
            placeholder="Add any resolution notes…"
            className="block w-full rounded-xl border border-zinc-200 px-3 py-2.5 text-sm text-zinc-900 placeholder:text-zinc-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 resize-none"
          />
        </div>

        <div className="flex flex-col-reverse sm:flex-row gap-3 pt-1">
          <Button color="secondary" className="sm:flex-1" onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button
            color="primary"
            className="sm:flex-1"
            onClick={handleResolve}
            disabled={submitting}
            submitting={submitting}
          >
            Resolve query
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ResolveQueryModal;
